export const NO_STRIPE_SUB_CANCEL_METHODS = new Set([
  'no_stripe_sub',
  'no_stripe_sub_expired',
]);

export function isNoStripeSubCancelMethod(method: unknown): boolean {
  return typeof method === 'string' && NO_STRIPE_SUB_CANCEL_METHODS.has(method);
}

export const CANCEL_CONFIRMATION_TRIAL = {
  title: 'Your free trial has been ended.',
  body: "You were never charged — Maestro trials don't require a card. You're welcome back anytime.",
} as const;

export const CANCEL_CONFIRMATION_PAID = {
  title: 'Your subscription has been cancelled.',
  body: "You won't be charged again. Thank you for being a Maestro member.",
} as const;

export function getCancelConfirmationCopy(method: unknown): typeof CANCEL_CONFIRMATION_TRIAL | typeof CANCEL_CONFIRMATION_PAID {
  return isNoStripeSubCancelMethod(method)
    ? CANCEL_CONFIRMATION_TRIAL
    : CANCEL_CONFIRMATION_PAID;
}
